export const addTranscriptionData = (transcriptionData) =>
	({
		type    : 'SET_TRANSCRIPTION_DATA',
		payload : { transcriptionData }
	});
export const addOldTranscriptionData = (transcriptionData) =>
	({
		type    : 'SET_OLD_TRANSCRIPTION_DATA',
		payload : { transcriptionData }
	});

export const removeClosePeer = (peerId) =>
	({
		type    : 'CLOSE_PEER',
		payload : { peerId }
	});

export const clearCCData = () =>
	({
		type : 'CLEAR_CC_DATA'
	});
